/**
 * 域名级别的页面配置（优先级高于路径后缀判断）
 * 字段与 getPageConfig 接口返回保持一致：logoUrl / copyright / favicon / showRightTool
 * key 支持两种格式：
 *   - 精确域名：'corp.example.com'
 *   - 通配子域名：'*.example.com'（匹配所有 xxx.example.com）
 */
export const domainConfig = {
  '*.linggongyouzhao.com': {
    title: '小招同学',
    logoUrl: require('@/assets/pageConfig/xiaozhao/xiaozhao-logo.jpg'),
    copyright: '灵工有招（深圳）数字科技有限公司版权所有Copyright © 2022-2026',
    benan: '粤ICP备2022013225号-1',
    favicon: require('@/assets/pageConfig/xiaozhao/xiaozhao-favicon.ico'),
    showRightTool: false,
    hiddenReleaseTaskBtn: true,
    hiddenSignSmsBtn: true,
    h5SignUrl: 'https://s.youweiwork.com/h5-act/index.html#/signLogin'
  }
}
